import Vue from 'vue';
import vuetify from './plugins/vuetify';
import './plugins';
import '@/assets/scss/_global.scss';

import App from './App.vue';
import router from './router';
import store from './store';

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

Vue.config.productionTip = false;

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

Vue.component('VueSlickCarousel', VueSlickCarousel);

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');

// tslint:disable-next-line:no-console
//console.log(`main.ts - 28 - ${new Date().toISOString().split('.')[0].replace('T', ' ')}`, 'I am running in LIVE mode: ' + process.env.VUE_APP_ISLIVE);

router.beforeEach((to, from, next) => {
  // console.log(`main.ts - 25 - to`, to);
  // console.log(`main.ts - 26 - from`, from);
  store.state.from = from.meta!.backLabel;
  next();
});
